/**
 * Created by fers on 05.02.16.
 */
/* eslint-disable react/no-multi-comp */

import React from 'react';
import PropTypes from 'prop-types';
import FRC from 'formsy-react-components';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Immutable from 'immutable';
import {getLocale, getLocalizedCountries} from '../locales';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import LoadingButton from './LoadingButton.react';
import {getLocalesMyAppSupports, DEFAULT_LOCALE} from '../../common/locales';
import {parse, format} from 'libphonenumber-js';
import {convertPhoneNumber} from '../../common/util/converter.ts';
import PlainText from './PlainText.react';
import SearchableSelect from './SearchableSelect.react';
import DatiQuerySelect from './DatiQuerySelect.react';
import DatiQueryDictionary from './DatiQueryDictionary.react';
import Input from './Input.react';
import JavaScriptEditor from './JavaScriptEditor.react';
import EmulateDatePicker from '../fw/EmulateDatePicker.react';
import ActionButton from '../fw/ActionButton.react';
import BarCodeInput from './BarCodeInput.react';
import SubForm from './SubForm.react';
import SafeHTML from './SafeHTML.react';

import './FormFields.scss';
import { ACCESS_TYPE_DEVELOPER, ACCESS_TYPE_PARTNER1, ACCESS_TYPE_PARTNER2 } from '../../common/model-api/UserType';
import { DEFAULT_GROUP_DEPTH, FORM_OPTION_GROUP_TYPE_PANEL, FORM_OPTION_GROUP_TYPE_TAB, GROUP_DEPTHS } from '../../common/model-api/FlowOptionGroupDefType';
import { groupCollapsed } from 'console';
import PasswordInput from './PasswordInput.react';

const messages = defineMessages({
	hide: {id: 'formFields.hide', defaultMessage: 'Hide'},
	show: {id: 'formFields.show', defaultMessage: 'Show'},
	hideHelp: {id: 'formFields.hideHelp', defaultMessage: 'Less information…'},
	showHelp: {id: 'formFields.showHelp', defaultMessage: 'More information…'},
});


const countries = getLocalizedCountries();
const { Checkbox, Textarea, CheckboxGroup, File } = FRC;

let emulDatePicker = String(navigator.userAgent).indexOf("JavaFX") !== -1;

interface FieldProps {
    column: string;
    extraArgs?: object;
}

export class Field extends React.Component<FieldProps> {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    static propTypes = {
        column: PropTypes.string.isRequired,
        extraArgs: PropTypes.object,
    };

    static contextTypes = {
        formFieldParent: PropTypes.object.isRequired,
    };

    render() {
        return this.context.formFieldParent._renderColumn(this.props.column, this.props.extraArgs ? this.props.extraArgs : {});
    }
}

interface FormSubmitClassProps {
    buttonTitle?: string;
    canSubmit?: boolean;
    className?: string;
    columnPrefix?: string;
    columnPrefixId?: string;
    disabled?: boolean;
    intl: IntlShape;
    isCreate?: boolean;
    isLoading?: boolean;
    key?: any;
    metadata: object;
}

class FormSubmitClass extends React.Component<FormSubmitClassProps> {

    static propTypes = {
        buttonTitle: PropTypes.string,
        canSubmit: PropTypes.bool,
		className: PropTypes.string,
        columnPrefix: PropTypes.string,
        columnPrefixId: PropTypes.string,
		disabled: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        isCreate: PropTypes.bool,
        isLoading: PropTypes.bool,
		key: PropTypes.any,
        metadata: PropTypes.object.isRequired,
    };

    static defaultProps = {
        isCreate: false,
        canSubmit: true,
		disabled: false,
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (<LoadingButton className={"btn btn-primary" + (this.props.className ? ' ' +  this.props.className : '')}
            disabled={!this.props.canSubmit || this.props.disabled}
            isLoading={this.props.isLoading}
            type="submit">{(
                this.props.buttonTitle
                    ?
                    this.props.buttonTitle
                    : (
                        this.props.isCreate
                            ? this.props.intl.formatMessage({
                                id: 'metadata.' + this.props.metadata.entity() + '.createButton',
                                defaultMessage: 'Create ' + this.props.metadata.singularName(),
                            }) : this.props.intl.formatMessage({
                                id: 'metadata.' + this.props.metadata.entity() + '.saveButton',
                                defaultMessage: 'Save ' + this.props.metadata.singularName(),
                            }))
                    )
            }</LoadingButton>);
    }
}

// class MyHtmlEditor extends React.Component {
//     static propTypes = {
//         onChange: PropTypes.func,
//     }
//
//     constructor(props) {
//         super(props);
//         this.state = {editorState: EditorState.createEmpty()};
//         this.onChange = (editorState) => {
//             if (this.props.onChange) {
//                 this.props.onChange(editorState);
//             }
//             this.setState({editorState});
//         };
//     }
//     render() {
//         return (
//             <Editor
//                 editorState={this.state.editorState}
//                 onChange={this.onChange}
//             />
//         );
//     }
// }

export let FormSubmit = injectIntl(FormSubmitClass);

export type ExtraParams = {
    required: boolean,
    display: Function,
    displayKey: string,
    onChange: Function,
    name: string,
    values: Array<Object>,
};

interface FormFieldsProps {
    children?: React.ReactNode;
    columnPrefix?: string;
    columnPrefixId?: string;
    columns?: any;
    data?: object;
    defaultValue?: object;
    fetchingCache?: object;
    idx?: string;
    intl?: object;
    isCreate?: boolean;
    metadata: object;
    onField?: (...args: unknown[]) => unknown;
    parent?: object;
    showAll?: boolean;
    useFloatingText?: boolean;
}

class FormFields extends React.Component<FormFieldsProps> {
    static propTypes = {
        children: PropTypes.node,
        columnPrefix: PropTypes.string,
        columnPrefixId: PropTypes.string,
        columns: PropTypes.any,
        data: PropTypes.object,
        defaultValue: PropTypes.object,
        fetchingCache: PropTypes.object,
        idx: PropTypes.string,
        intl: PropTypes.object,
        isCreate: PropTypes.bool,
        metadata: PropTypes.object.isRequired,
        onField: PropTypes.func,
        parent: PropTypes.object,
        showAll: PropTypes.bool,
        useFloatingText: PropTypes.bool,
    };

    static defaultProps = {
        data: {},
        isCreate: false,
        showAll: false,
        useFloatingText: true,
    };

    static childContextTypes = {
        formFieldParent: PropTypes.object.isRequired,
    };

    getChildContext() {
        return { formFieldParent: this };
    }

    constructor(props) {
        super(props);

        if (props.fetchingCache) {
            this.fetchingCache = props.fetchingCache;
        } else {
            this.fetchingCache = {};
        }

        /* in create mode we collect default values */
        if (props.isCreate) {
            this.defaultValue = props.metadata.defaultValues(props.parent ? props.parent : {});

            if (this.props.defaultValue) {
                this.defaultValue = {...this.defaultValue, ...this.props.defaultValue};
            }

            this.state = {
                data: this.defaultValue
            };
        } else {
            this.state = {
                data: this.props.data
            };
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    isCreate() : boolean {
        return this.props.isCreate;
    }

    _getEditComponent(metadata, column : string) {
        let fields = metadata.fields();

        let type = fields[column];

        if (type.type === "string") {
            if (type.readOnly) {
                return PlainText;
            } else {
                return Input;
            }
        } else if (type.type === "expression") {
            return Input;
        } else if (type.type === "text") {
            if (type.readOnly) {
                return PlainText;
            } else {
                return Textarea;
            }
        } else if (type.type === "html") {
            if (type.readOnly) {
                return PlainText;
            } else {
                return Textarea;
            }
        } else if (type.type === "javascript") {
            return JavaScriptEditor;
        } else if (type.type === "object") {
            return Textarea;
        } else if (type.type === "password") {
            return PasswordInput;
        } else if (type.type === "EAN" || type.type === "ean") {
            return BarCodeInput;
        } else if (type.type === "boolean") {
            return Checkbox;
        } else if (type.type === "relation") {
            return SearchableSelect;
        } else if (type.type === "relations") {
            return SearchableSelect;
        } else if (type.type === "enum") {
            if (type.datiquery || type.datiQuery) {
                return DatiQuerySelect;
            }
            return SearchableSelect;
        } else if (type.type === "enums") {
            if (type.datiquery || type.datiQuery) {
                return DatiQuerySelect;
            }
            return CheckboxGroup;
        } else if (type.type === "dictionary") {
            return DatiQueryDictionary;
        } else if (type.type === "form") {
            return SubForm;
        } else if (type.type === "country") {
            return SearchableSelect;
        } else if (type.type === "certificate" || type.type === "file" || type.type === "image") {
            return File;
        } else if (type.type === "js-action") {
            return ActionButton;
        } else if (emulDatePicker && (type.type === "date" || type.type === "dateTime" || type.type === "datetime")) {
            return EmulateDatePicker;
        }

        return Input;
    }

    _extractRelationName(item, extraParams : ExtraParams) {
        if (!item) {
            return "?";
        }
        if (extraParams['displayKey']) {
            return item[extraParams['displayKey']];
        } else if (extraParams['display']) {
            let func = extraParams['display'];
            return func(item, extraParams);
        }
    }

	// eslint-disable-next-line max-params
    _getValueForEdit(metadata, column, value, extraParams : ExtraParams, localeAddon : string) {
        let fields = metadata.fields();

        let type = fields[column];

        if (!type) {
            throw new Error("Missing type " + column + " in " + metadata.entity());
        }
        let result = {
            key: column,
            required: (extraParams && 'required' in extraParams) ? extraParams.required : ((fields[column] && 'required' in fields[column]) ? fields[column].required : false),
        };


        if (this.props.columnPrefixId) {
            result['name'] = this.props.columnPrefixId + "." + type.fieldName + (localeAddon ? localeAddon : "");
        } else {
            result['name'] = column + (localeAddon ? localeAddon : "");
        }

        if (type.visibility) {
            let isVisible = !Boolean(this.state.data) || type.visibility(this.state.data, this.props.columnPrefixId);

            result['disabled'] = !isVisible;
            if (!isVisible) {
                return result;
            }
        }
        if (type.developersOnly || type.accessType === ACCESS_TYPE_DEVELOPER) {
            result['rowDevelopers'] = true;
        }
        if (type.partner1Only || type.accessType === ACCESS_TYPE_PARTNER1) {
            result['rowPartner1'] = true;
        }
        if (type.partner2Only || type.accessType === ACCESS_TYPE_PARTNER2) {
            result['rowPartner2'] = true;
        }

        if (type.internal === true) {
            result['rowInternal'] = true;
        }

        if (extraParams && extraParams.hidden) {
            result['disabled'] = true;
        }
        if ('readOnly' in type && type.readOnly) {
            result['readOnly'] = true;
        }
        if (extraParams && 'readOnly' in extraParams && type.extraParams.readOnly) {
            result['readOnly'] = true;
        }

        if ('autoFocus' in type && type.autoFocus) {
            result['autoFocus'] = true;
        }
        if (extraParams && 'autoFocus' in extraParams && type.extraParams.autoFocus) {
            result['autoFocus'] = true;
        }

        if (fields[column] && fields[column].validations) {
            result['validations'] = {};

            for (let key of Object.keys(fields[column].validations)) {
                if (key === "isEmail" ||
                    key === "isUrl" ||
                    key === "isNumeric" ||
                    key === "isAlphanumeric" ||
                    key === "isInt" ||
                    key === "isFloat") {
                    result['validations'][key] = fields[column].validations[key];
                } else if (key === "matchRegexp") {
                    // nosemgrep
                    result['validations'][key] = new RegExp(fields[column].validations[key]);
                }
            }
        }

        if (extraParams && extraParams.validate !== undefined) {
            if (!result['validations']) {
                result['validations'] = {};
            }

            result['validations']['custom'] = extraParams.validate;
        }

		if (extraParams && extraParams.placeholder !== undefined) {
			result['placeholder'] = extraParams.placeholder;
		} else if (type.placeholder) {
            result['placeholder'] = this.props.intl.formatMessage({
                id: "metadata." + metadata.entity() + "." + column + ".placeholder",
                defaultMessage: type.placeholder
            });
        }

        let label = '';
        if (extraParams && extraParams.name !== undefined) {
            label = extraParams.name;
        } else if (fields[column] && fields[column].name) {
			if (fields[column].localized) {
				label = fields[column].name;
			}
			else {
				label = this.props.intl.formatMessage({
					id: "metadata." + metadata.entity() + "." + column,
					defaultMessage: fields[column].name
				});
			}
        }

        if (this.props.useFloatingText) {
            result['label'] = label;
        } else {
			if (!['string', 'boolean'].includes(fields[column].type)) {
				result['hintText'] = label;
			}
            result['layout'] = 'elementOnly';
        }

        if (fields[column] && fields[column].description) {
			if (fields[column].localized) {
				result['help'] = fields[column].description;
			}
			else {
				result['help'] = this.props.intl.formatMessage({
					id: "metadata." + metadata.entity() + "." + column + ".description",
					defaultMessage: fields[column].description
				});
			}
			result['rowClassName'] = 'withHelp';
        }

		if (fields[column] && fields[column].label) {
			result['rowLabel'] = fields[column].label;
		}

		if (extraParams && extraParams.descriptionHtml !== undefined) {
            label = extraParams.descriptionHtml;

			if (label) {
				result['rowClassName'] = 'withHelp';
			}
        } else if (fields[column] && fields[column].descriptionHtml) {
            if (fields[column].type === 'text' || fields[column].type === 'file') {
                // textarea has no support for htmlHelp
                result['help'] = fields[column].descriptionHtml;
            } else {
                result['htmlHelp'] = fields[column].descriptionHtml;
            }
			result['rowClassName'] = 'withHelp';
		}

		if (fields[column].rowClassName) {
			result['rowClassName'] = (result['rowClassName'] || '') + ' ' + fields[column].rowClassName;
		}
        if (result['rowDevelopers']) {
            result['rowClassName'] = (result['rowClassName'] || '') + ' ' + 'developer-only';
        }
        if (result['rowPartner1']) {
            result['rowClassName'] = (result['rowClassName'] || '') + ' ' + 'partner1-only';
        }
        if (result['rowPartner2']) {
            result['rowClassName'] = (result['rowClassName'] || '') + ' ' + 'partner2-only';
        }
        if (result["rowInternal"]) {
            result['rowClassName'] = (result['rowClassName'] || '') + ' ' + 'internal-only';
            //read only
            result['readOnly'] = true;
            result['required'] = false;
        }

		result['rowClassName'] = (result['rowClassName'] || '') + ' ' + column;

        if (extraParams && extraParams.addonBefore !== undefined) {
            result['addonBefore'] = extraParams.addonBefore;
        } else if (fields[column] && fields[column].addonBefore) {
            result['addonBefore'] = fields[column].addonBefore;
        }

        if (extraParams && extraParams.addonAfter !== undefined) {
			result['addonAfter'] = extraParams.addonAfter;
		} else if (fields[column] && fields[column].addonAfter) {
			result['addonAfter'] = fields[column].addonAfter;
		}

        if (extraParams && extraParams.title !== undefined) {
            result['title'] = extraParams.title;
        }
        if (extraParams && extraParams.lang !== undefined) {
            result['lang'] = extraParams.lang;
        }

        result['onChange'] = (key, value, payload) => {
            let immutableData = Immutable.Map(this.state.data);
            let mutableData = this.state.data;
            let hasChange = false;

            let modifyValues = (property, value) => {

                if (type.type === "phoneNumber") {
                    value = convertPhoneNumber(value);
                }
                if (type.type === 'file' || type.type === 'certificate' || type.type === 'image') {
                    /* do not overwrite data */
                    return;
                }

                if (type.translatable) {
                    let locale = DEFAULT_LOCALE;
                    if (column === property) {
                        locale = key.substring(column.length + 1);
                    }

                    let stateData = this.state.data;

                    if (!(property + '_l' in stateData)) {
                        stateData = {
                            ...stateData,
                            [property + '_l']: []
                        };
                    }

                    let localeIdx = stateData[property + '_l'].findIndex((row) => row.locale === locale);
                    immutableData = immutableData.updateIn([property + '_l'], [], (update) => {
                        if (localeIdx === -1) {
                            update.push({
                                locale: locale,
                                content: value
                            });
                        } else {
                            update[localeIdx].content = value;
                        }
                        return update;
                    });

                    mutableData = {
                        ...immutableData.toObject(),
                        [property.split(".").pop()]: value,
                    };

                    hasChange = true;
                } else {
                    immutableData = immutableData.updateIn(property.split("."), {}, (update) => {
                        update = value;
                        return update;
                    });

                    mutableData = {
                        ...immutableData.toObject(),
                        [property.split(".").pop()]: value,
                    };

                    hasChange = true;
                }

            };

            if (extraParams && extraParams['onChange']) {
                extraParams['onChange'](key, value, payload, modifyValues);
            }

            if (type.type === "relation" || type.type === "relations") {
                let values;
                let primaryKey = type.to().getPrimaryKey().key;

                if (extraParams && extraParams['values']) {
                    values = extraParams['values'];
                    if (Array.isArray(values)) {
                        value = values.find((row) => row[primaryKey] === value);
                    } else {
                        value = Object.keys(values)[value];
                    }
                } else if (type['values']) {
                    if (type['datiQuery'] || type['datiquery']) {
                        values = type['values'];
                        if (Array.isArray(values)) {
                            if (type.type === 'relations') {
                                value = values.filter((row) => {
                                    for (let val of value) {
                                        if (row[primaryKey] === val) {
                                            return true;
                                        }
                                    }

                                    return false;
                                });
                            } else {
                                value = values.find((row) => row[primaryKey] === value);
                            }
                        } else {
                            value = Object.keys(values)[value];
                        }
                    }
                } else {
                    values = type['values'];
                    if (Array.isArray(values)) {
                        value = values.find((row) => row[primaryKey] === value);
                    } else {
                        value = values[column];
                    }
                }
            }

            modifyValues(key, value);

            if (hasChange) {
                this.setState({data: mutableData});
            }

            return true;
        };

        let maxlength = 255;
        if (fields[column].maxLength) {
            maxlength = fields[column].maxLength;
        }

        if (type.type === "text") {
            result['rows'] = 4;
            maxlength = 0;
            value = value || "";
        } else if (type.type === "form") {
            if (fields[column].subForm) {
                result['subForm'] = fields[column].subForm;
            }

            result['columnPrefix'] = this.props.columnPrefix ? this.props.columnPrefix + "" + type['fieldName'] : result['name'];
            result['columnPrefixId'] = this.props.columnPrefixId ? this.props.columnPrefixId + "." + type['fieldName'] : result['name'];

            result['fetchingCache'] = this.fetchingCache;
        } else if (type.type === "file" || type.type === "certificate" || type.type === "image") {
            if (value) {
                /* if there is value for file, it is not required */
                result['required'] = false;
            }
            if (type.fileContentTypes) {
                result['accept'] = type.fileContentTypes;
            }
            if (type.type === "certificate") {
                result['accept'] = 'application/x-pkcs12,application/x-pem-file,application/x-x509-ca-cert,.pem,.pfx,.key' + (type.fileContentTypes || '');
            }

            if (value) {
                result['htmlHelp'] = "Vyplněno";
            }

            // we can't set value of <input type='file'>
            return {
                ...result
            };

        } else if (type.type === "object") {
            maxlength = 0;
        } else if (type.type === "string") {
            maxlength = 8000;
			value = value || "";
        } else if (type.type === "boolean") {
            if (value === "false") {
                value = false;
            }
            value = value ? true : false;
        } else if (type.type === "expression") {
            maxlength = null;
        } else if (type.type === "js-action") {
            result['onClick'] = type['onClick'];
        } else if (type.type === "hostname") {
            if (!result['validations']) {
                result['validations'] = {};
            }
            result['validations']['matchRegexp'] = /^((([A-Za-z0-9][a-zA-Z0-9\.\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])|([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+))(\:[0-9]+)?$/;
            value = value || "";
        } else if (type.type === "hostnameWithoutPort") {
            if (!result['validations']) {
                result['validations'] = {};
            }
            result['validations']['matchRegexp'] = /^((([A-Za-z0-9][a-zA-Z0-9\.\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])|([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+))$/;
            value = value || "";
        } else if (type.type === "html") {
            if (type.readOnly) {
                result['renderAsHtml'] = true;
            }
            result['rows'] = 6;
            maxlength = 0;
        } else if (type.type === "javascript") {
            result['rows'] = 8;
            maxlength = 0;
            if (fields[column].globalVariables) {
                result['globalVariables'] = fields[column].globalVariables;
            }
        } else if (type.type === "password") {
            result['type'] = "password";
        } else if (type.type === "int") {
            result['validations'] = "isInt";
        } else if (type.type === "number") {
            result['validations'] = "isNumeric";
        } else if (type.type === "money") {
            result['validations'] = "isNumeric";
        } else if (type.type === "email") {
            result['type'] = "email";
        } else if (type.type === "phoneNumber") {
            if (value) {
                let parsed = parse(value);
                if (parsed) {
                    value = format(parsed, 'International');
                }
            }
        } else if (type.type === "dateTime" || type.type === "datetime" || type.type === "date") {
            if (value) {
                try {
                    value = new Date(value).toISOString().slice(0, 10);
                } catch (e) {
                    try {
                        if (typeof value === 'string') {
                            value = value.substring(0, 10);
                        }

                        value = new Date(value).toISOString().slice(0, 10);
                    } catch (e) {
                        /* ignore error */
                    }
                }
            }

            if (emulDatePicker) {
                result['locale'] = this.props.intl.lang;
            } else {
                result['type'] = "date";
            }

        } else if (type.type === "relation" || type.type === 'relations') {
            /* in relation we use extraParams['values'] for possible values */
            let values = [
            ];

            /* if item is not required, allow empty value */
            if (!type['required'] && type.type !== 'relations') {
                values.push({
                   label: "-",
                   value: ""
                });
            }

            let key = type.to().getPrimaryKey().key;

            if (extraParams && extraParams['values']) {
                for (let item of extraParams['values']) {
                    if (item !== null && item !== undefined) {
                        values.push({
                            label: this._extractRelationName(item, extraParams),
                            value: item[key],
                        });
                    }
                }
            } else if (type['values']) {
                for (let item of type['values']) {
                    if (item !== null && item !== undefined) {
                        values.push({
                            label: this._extractRelationName(item, type),
                            value: item[key]
                        });
                    }
                }
            } else {
                /* we do not have possible values, so we add just one item that contains current value */
                values.push({
                    label: this._extractRelationName(value, extraParams),
                    value: value[key]
                });
            }

            if (type.type === 'relations') {
                return {
                    value: value,
                    options: values,
                    multiple: true,
                    ...result
                };
            } else {
                if (typeof value !== "string") {
                    /* extract value */
                    value = value ? value[key] : null;
                }

                /* if value is null and we have something in list, select it */
                if (!value && values.length > 0) {
                    value = values[0].value;
                }

                return {
                    value: value,
                    options: values,
                    ...result
                };
            }
        } else if (type.type === "enum" || type.type === "enums" || type.type === "country" || type.type === "dictionary") {
            let values = [];


            let items;
            if (extraParams && extraParams['values']) {
                items = extraParams['values'];
            } else {
                items = type['values'];
            }

            let translate = true;

            if (type.type === "country" && !items) {
                translate = false;
                items = countries;
            }

            if (!items) {
                items = {};
            }

            if (typeof items === 'function') {
                items = items(this.state.data, this.state.columnPrefixId, items);
            }
            for (let item of Object.keys(items)) {
                let label = items[item]['name'];

                if (label && (typeof label === "object" || typeof label === 'function')) {
                    let locale = getLocale();
                    label = label[locale]; // nosemgrep
                } else if (translate) {
                    label = this.props.intl.formatMessage({
                        id: "metadata." + metadata.entity() + "." + column + ".values." + item + ".name",
                        defaultMessage: items[item]['name']
                    });
                }

                let disabled = false;

                if (items[item] && 'disabled' in items[item]) {
                    if (items[item].disabled && typeof items[item].disabled === "function") {
                        disabled = items[item].disabled(this.state.data);
                    } else {
                        disabled = items[item].disabled ? true : false;
                    }
                }

                values.push({
                    label: label,
                    value: item,
                    disabled: disabled
                });
            }

            if (type.type === "enums" && !value) {
                value = [];
            }

            /* in enum with empty list, create one value */
            if (type.type === "enum" && values.length === 0 && value) {
                values = [
                    {
                        label: value,
                        value: value,
                    },
                ];
            }

            /* in enum with empty list, create one value */
            if (type.type === "enums" && values.length === 0 && value) {
                if (!Array.isArray(value)) {
                    if (typeof value === 'string' && value.indexOf(",")) {
                        value = value.split(",");
                    } else {
                        value = [value];
                    }
                }
                values = value.map((a) => {
                    return ({
                        label: a,
                        value: a,
                    });
                });
            }

            if (type.datiquery || type.datiQuery) {
                if (type.type === "enums") {
                    result['multiple'] = true;
                }
                result['datiQuery'] = type.datiquery || type.datiQuery;
                result['datiQueryHasParameters'] = type.datiQueryHasParameters;
                result['onValuesFetched'] = type.onValuesFetched;
                if (type.datiQueryHasParameters) {
                    let data = this.state.data;
                    for (let key of Object.keys(data)) {
                        let val = data[key];
                        let columnPrefixId = this.props.columnPrefixId || type['columnPrefixId'];
                        if (columnPrefixId && key.startsWith(columnPrefixId)) {
                            key = key.replace(columnPrefixId, "");
                        }
                        if (key.startsWith("flowOptionDefs_")) {
                            key = key.replace("flowOptionDefs_", "");
                        }

                        result['datiQuery'] = result['datiQuery'].replace(":" + key, "'" + val + "'");
                    }
                }

                result['channel_id'] = type.channel_id || (extraParams ? extraParams.channel_id : undefined);
                result['channel'] = type.channel;
                result['organisation_id'] = type.organisation_id || (extraParams ? extraParams.organisation_id : undefined);
                result['flow_id'] = type.flow_id || (extraParams ? extraParams.flow_id : undefined);
                result['fetchingCache'] = this.fetchingCache;
            }

            if (type.datiquery2 || type.datiQuery2) {
                result['datiQuery2'] = type.datiquery2 || type.datiQuery2;

                result['channel2_id'] = type.channel2_id || (extraParams ? extraParams.channel2_id : undefined);
                result['channel2'] = type.channel2;
                result['organisation_id'] = type.organisation_id || (extraParams ? extraParams.organisation_id : undefined);
                result['flow_id'] = type.flow_id || (extraParams ? extraParams.flow_id : undefined);
            }

            return {
                value: value,
                options: values,
                ...result
            };
        }

		if (value === undefined && type.defaultValue !== undefined) {
			value = type.defaultValue;
		}

        if (maxlength > 0) {
            result['maxLength'] = maxlength;
        }

        return { value: value, ...result };
    }

	// eslint-disable-next-line max-params
    _renderOneColumn(column, colAddon, value, localeAddon) {
        let addons = this._getValueForEdit(this.props.metadata, column, value, colAddon, localeAddon);
        if (addons['disabled']) {
            return <span key={addons['name']}></span>;
        }

        if (this.props.onField) {
            addons = this.props.onField(column, addons);
        }

        /* emulate read only support */
        if (addons['readOnly']) {
            addons['disabled'] = true;
        }


        let columnForData = column;
        if (this.props.columnPrefix && columnForData.startsWith(this.props.columnPrefix)) {
            columnForData = columnForData.substring(this.props.columnPrefix.length, columnForData.length);
        }
        if (this.props.columnPrefixId) {
            columnForData = this.props.columnPrefixId + "." + columnForData;
        }

        let fields = this.props.metadata.fields();
        let type = fields[column];

        let isHelpShowed = false;
        if (this.state['help-' + column]) {
            isHelpShowed = true;
        }

        return (<div>{React.createElement(
            this._getEditComponent(this.props.metadata, column),
            {
                ...addons
            })

            } {type['longDescription'] ?
            <div className="form-group row">
                <div className="col-sm-3 control-label"></div>
                <div className="col-sm-9 help-block" onClick={() => this.setState({['help-' + column]: !isHelpShowed})}>
                    <div><span ariaHidden="true" className="fa fa-info-circle"></span>&nbsp;{isHelpShowed
                ? <span>{this.props.intl.formatMessage(messages.hideHelp)}</span>
                : <span>{this.props.intl.formatMessage(messages.showHelp)}</span>
            }</div> {isHelpShowed ? <SafeHTML value={type['longDescription']} /> : null}</div></div> : null}</div>
            );
    }

    _renderColumn(column, colAddon) {
        let fields = this.props.metadata.fields();

        let columnForData = column;
        if (this.props.columnPrefix && columnForData.startsWith(this.props.columnPrefix)) {
            columnForData = columnForData.substring(this.props.columnPrefix.length, columnForData.length);
        }

        if (fields[column] && fields[column].translatable) {
            return getLocalesMyAppSupports().map((locale, idx) => {
                let value = "";

                if (this.state.data[column + "_l"]) {
                    let el = this.state.data[columnForData + "_l"].find((a) => a.locale === locale);
                    if (el) {
                        value = el.content;
                    }
                } else if (locale === DEFAULT_LOCALE) {
                    value = this.state.data[columnForData];
                }

                let addons = {...colAddon, addonBefore: locale, title: locale, 'lang': locale};
                if (locale !== DEFAULT_LOCALE) {
                    addons['required'] = false;
                    addons['name'] = " ";
                }

                return (
                    <div className={idx > 0 ? "langAddon" : ""} key={locale}>
                        {this._renderOneColumn(column, addons, value, "_" + locale)}
                    </div>
                );
            });
        }

        let value = null;
        if (this.state.data && columnForData in this.state.data && this.state.data[columnForData] !== undefined) {
            value = this.state.data[columnForData];
        } else if (fields[column] && 'defaultValue' in fields[column]) {
            if (fields[column].defaultValue && typeof fields[column].defaultValue === "function") {
                value = fields[column].defaultValue({});
            } else {
                value = fields[column].defaultValue;
            }
        }

        return this._renderOneColumn(column, colAddon, value);
    }

	makeGroups(colArray) {
		let groups = {};
		let notGroupedItems = [];

		let fields = this.props.metadata.fields();

		colArray.forEach(item => {
			let field = fields[item];

			if (field && field.group) {
				let groupId = field.group.id;

				if (!Object.keys(groups).includes(groupId)) {
					groups[groupId] = field.group;
					groups[groupId].fields = [];
				}

				groups[groupId].fields.push(field);
			}
			else {
				notGroupedItems.push(field);
			}
		});

		let groupArray = [];
		Object.keys(groups).forEach(groupId => {
			groups[groupId].fields.sort((a, b) => a.order - b.order);

            let hasAnyFieldVisible = false;
            for (let field of groups[groupId].fields) {
                if (field.hidden) {
                    continue;
                }
                if (!field.visibility) {
                    hasAnyFieldVisible = true;
                    break;
                } else {
                    if (field.visibility(this.state.data, this.props.columnPrefixId)) {
                        hasAnyFieldVisible = true;
                        break;
                    }
                }
            }

            if (!hasAnyFieldVisible) {
                return;
            }

			groupArray.push(groups[groupId]);
		});

		groupArray.sort((a, b) => a.order - b.order);

        let rootGroup = {
            root: true,
            level: 0,
            fields: [],
            items: [],
        };

        let idx = 0;
        function processGroup(parentGroup, currentLevel, isPanel) {
            if (idx >= groupArray.length) {
                return;
            }

            let group = groupArray[idx];
            let level = GROUP_DEPTHS[group.depthlevel || DEFAULT_GROUP_DEPTH].level;

            if (level < currentLevel) {
                return;
            }

            if (group.type === FORM_OPTION_GROUP_TYPE_TAB) {
                if (!isPanel) {
                    let groupObject = {
                        level: level,
                        type: group.type,
                        items: [],
                    };
                    parentGroup.items.push(groupObject);
                    groupObject.items.push({
                        level: level,
                        type: group.type,
                        group: group,
                        fields: [],
                        items: [],
                    });
                    idx++;
                    processGroup(groupObject, currentLevel, true);
                    return;
               }
            } else {
                if (isPanel) {
                    return;
                }
            }

            if (level >= currentLevel) {
                let groupObject = {
                    level: level,
                    type: group.type,
                    group: group,
                    fields: [],
                    items: [],
                };
                parentGroup.items.push(groupObject);

                idx++;
                processGroup(groupObject, currentLevel + 1, isPanel);
            }
        }


        /* make a tree from groups according to level and group tabs separately*/
        while (idx < groupArray.length) {
            processGroup(rootGroup, 0);
        }

        let groupArray2 = [];
        groupArray2.push(rootGroup);

		if (notGroupedItems.length) {
			groupArray2.push({
                group: {
                    fields: notGroupedItems
                }
            });
		}

		return groupArray2;
	}

    _renderGroupList(groups, colAddons) {
        return groups.map((group, idx) => {
            if (group.group) {
                return this._renderGroup(group, colAddons, idx);
            } else {
                if (group.type === FORM_OPTION_GROUP_TYPE_TAB) {
                    return this._renderPanel(group, colAddons, idx);
                } else if (group.items) {
                    return this._renderGroupList(group.items, colAddons);
                }
            }
        });
    }

    _renderPanel(groupObject, colAddons, idx) {

        if (groupObject.group) {
            throw new Error("Can't contain group in panel");
        }

        return (
        <div className={'formGroup formGroupLine '} key={"a" + idx}>
            <ul className="nav nav-tabs" role="tablist">
                {groupObject.items.map((groupObj, idx2) => {
                    let group = groupObj.group;

                    return (<li className={"nav-item" + (idx2 === 0 ? " active" : "")} key={idx2} role="presentation">
                        <a aria-controls={"simple-tabpanel-" + idx + "-" + idx2} className="nav-link" data-toggle="tab" href={"#simple-tabpanel-" + idx + "-" + idx2} id={"simple-tab-" + idx + "-" + idx2}>{group.name}</a>
                    </li>);
                })}
            </ul>

            <div className="tab-content">
                {groupObject.items.map((groupObj, idx2) => {
                    let group = groupObj.group;

                    let isHelpShowed = false;
                    if (this.state['group-help-' + group.id]) {
                        isHelpShowed = true;
                    }

                    return (<div aria-labelledby={"simple-tab-" + idx + "-" + idx2} className={"tab-pane" + (idx2 === 0 ? " active" : "")} id={"simple-tabpanel-" + idx + "-" + idx2} key={idx2} role="tabpanel">
                        {group.description || group.longDescription ? <p className="formGroupDescription" style={{"color": "gray"}}>
                        {group.description ? <SafeHTML value={group.description} /> : null}
                        {group.longDescription ? <div><div onClick={() => this.setState({['group-help-' + group.id]: !isHelpShowed})}><span ariaHidden="true" className="fa fa-info-circle"></span>&nbsp;{isHelpShowed
                            ? <span>{this.props.intl.formatMessage(messages.hideHelp)}</span>
                            : <span>{this.props.intl.formatMessage(messages.showHelp)}</span>
                        }</div> {isHelpShowed ? <SafeHTML value={group.longDescription} /> : null}</div> : null}
                    </p> : null}
                        <div className="fields">
                            {group.fields.map(field => {
                                return this._renderColumn(field.key, colAddons[field.key]);
                            })}
                        </div>
                    </div>);
                })}
            </div>
        </div>
        );
    }

	_renderGroup(groupObject, colAddons, idx) {
        let isCollapsed = false;
        let isHelpShowed = false;
        let group = groupObject.group;
        if (group.collapsed) {
            if (!('group-' + group.id in this.state) || this.state['group-' + group.id]) {
                isCollapsed = true;
            }
        }

        if (this.state['group-help-' + group.id]) {
            isHelpShowed = true;
        }

		return (
			<div className={'formGroup formGroupLine ' + (group.onlyFlags ? ' onlyFlags' : '')} key={"a" + (group.id || idx)}>
				{group.name ? <h4>{group.name}</h4> : null}
				{group.description || group.longDescription ? <p className="formGroupDescription" style={{"color": "gray"}}>
                    {group.description ? <SafeHTML value={group.description} /> : null}
                    {group.longDescription ? <div><div onClick={() => this.setState({['group-help-' + group.id]: !isHelpShowed})}><span ariaHidden="true" className="fa fa-info-circle"></span>&nbsp;{isHelpShowed
                        ? <span>{this.props.intl.formatMessage(messages.hideHelp)}</span>
                        : <span>{this.props.intl.formatMessage(messages.showHelp)}</span>
                    }</div> {isHelpShowed ? <SafeHTML value={group.longDescription} /> : null}</div> : null}
                </p> : null}
                {group.collapsed ?
                    <div style={{paddingBottom: '1em'}}><div className="btn btn-inline" onClick={() => this.setState({['group-' + group.id]: !isCollapsed})}>{isCollapsed
                        ? <span>{this.props.intl.formatMessage(messages.show)} &gt;&gt;</span>
                        : <span>{this.props.intl.formatMessage(messages.hide)} &gt;&gt;</span>
                    }</div></div>
                : null}

				{isCollapsed ? null : <div className="fields">
					{group.fields.map(field => {
						return this._renderColumn(field.key, colAddons[field.key]);
					})}
				</div>}

                {groupObject.items ? <div className="row">
                    <div className="col-sm-1">
                    </div>
                    <div className="col-sm-10" style={{"paddingLeft": "28px"}}>
                        {this._renderGroupList(groupObject.items, colAddons)}
                    </div>
                </div> : null}
			</div>
		);
	}

    render() {
        let { columns, metadata } = this.props;

        if (!columns) {
            columns = Object.keys(metadata.fields());
        }

        /* we support array or map of keys and their values */
        let colArray = columns;
        let colAddon = columns;

        if (Array.isArray(columns)) {
            colAddon = {};
        } else {
            colArray = Object.keys(colArray);
        }

		let groups = this.makeGroups(colArray);

        if (React.Children.count(this.props.children) > 0 && this.props.showAll === false) {
            if (React.Children.count(this.props.children) === 1) {
                return (
                    this.props.children
                );
            } else {
                return (
                    <div key={"a" + this.props.idx}>
                        {this.props.children}
                    </div>
                );

            }
        } else {
            return (
                <div key={"a" + this.props.idx}>
					{this._renderGroupList(groups, colAddon)}

                    {this.props.children}
                </div>
            );
        }
    }
}

export default injectIntl(FormFields);
